<template>
  <!--
      	作者：zhuchangtao
      	时间：2021-07-01
      	描述：打卡抽奖活动-抽奖活动列表
      -->
  <div class="user">
    <!-- <div class="common-form">秒杀抽奖活动列表</div> -->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加抽奖活动</el-button>
    </div>

    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="formInline.status" placeholder="抽奖活动状态">
            <el-option label="全部状态" value="-1"></el-option>
            <el-option v-for="(item,index) in status" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formInline.title" placeholder="请输入抽奖活动标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="sweepstakes_id" label="抽奖活动ID" width="100" ></el-table-column>
            <el-table-column prop="sweepstakes_name" label="抽奖活动标题" ></el-table-column>

            <el-table-column prop="sort" label="抽奖活动排序" width="120"></el-table-column>
             <el-table-column prop="type_text" label="抽奖活动类型" width="120"></el-table-column>
            <el-table-column prop="status_text" label="抽奖活动状态" width="120"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="150">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="recordClick(scope.row)" type="text" size="small">记录</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
           :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import SweepstakesApi from '@/api/sweepstakes.js';
  export default {
    components: {},
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form: {},
        /*是否打开添加弹窗*/
        open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        /*当前编辑的对象*/
        userModel: {},
        formInline: {},
        status: ['未生效', '生效'],
          file:{},
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();

    },
    methods: {
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        SweepstakesApi.sweepstakesList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {
              self.loading = false;
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*打开添加*/
      addClick() {
        this.$router.push('/plus/sweepstakes/sweepstakes/add');
      },
       /*打开记录*/
      recordClick(row){
        let sweepstakes_id = row.sweepstakes_id;
        this.$router.push({
          path: '/plus/sweepstakes/sweepstakes/record',
          query: {
            sweepstakes_id: sweepstakes_id
          }
        })
      },
      /*打开编辑*/
      editClick(row) {
        let sweepstakes_id = row.sweepstakes_id;
        this.$router.push({
          path: '/plus/sweepstakes/sweepstakes/edit',
          query: {
            sweepstakes_id: sweepstakes_id
          }
        })
      },

      /*删除*/
      deleteClick(row) {

        let self = this;
        self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          SweepstakesApi.delSweepstakes({
              sweepstakes_id: row.sweepstakes_id
            }, true)
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，抽奖活动删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.$message.error('错了哦，这是一条错误消息');
              }
            })
            .catch(error => {

            });

        }).catch(() => {});
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakes/index.vue